<template>
  <div :class="[$style.pageWrapper, 'type-body-medium']">
    <!-- Gradient Background -->
    <div :class="$style.gradientBg"></div>

    <!-- Main Content Card -->
    <div :class="$style.contentCard">
      <!-- Stepper -->
      <div :class="$style.stepper">
        <div :class="[$style.stepItem, $style.completed]">
          <span :class="[$style.stepNumber, 'type-label-small-emphasized']"
            >1</span
          >
          <span :class="[$style.stepLabel, 'type-label-small-emphasized']"
            >Account</span
          >
        </div>

        <div :class="[$style.stepItem, $style.active]">
          <span :class="[$style.stepNumber, 'type-label-small-emphasized']"
            >2</span
          >
          <span :class="[$style.stepLabel, 'type-label-small-emphasized']"
            >Plan</span
          >
        </div>

        <div :class="$style.stepItem">
          <span :class="[$style.stepNumber, 'type-label-small-emphasized']"
            >3</span
          >
          <span :class="[$style.stepLabel, 'type-label-small-emphasized']"
            >Payment</span
          >
        </div>
      </div>

      <!-- Step: Plan Selection -->
      <div
        v-if="checkoutStep === 'select'"
        :class="$style.planContent"
      >
        <!-- Plan Type Selection -->
        <div :class="$style.formHeader">
          <div :class="$style.mascotContainer">
            <LogoComponent></LogoComponent>
          </div>
          <h2 :class="[$style.formTitle, 'type-headline-medium']">
            Choose Your Plan
          </h2>
        </div>

        <div :class="$style.planTypeGrid">
          <button
            :class="[
              $style.planTypeCard,
              { [$style.selected]: selectedPlanType === 'free' },
            ]"
            @click="selectedPlanType = 'free'"
          >
            <h3 class="type-title-small">Free Trial</h3>
            <p class="type-body-small">30 days</p>
          </button>

          <button
            :class="[
              $style.planTypeCard,
              { [$style.selected]: selectedPlanType === 'paid' },
            ]"
            @click="selectedPlanType = 'paid'"
          >
            <h3 class="type-title-small">Subscription</h3>
            <p class="type-body-small">Per seat</p>
          </button>
        </div>
        <div :class="$style.description">
          <p class="type-body-medium">
            Start with a free trial or unlock premium features
          </p>
        </div>

        <!-- Details Panel -->
        <div :class="$style.detailsPanel">
          <!-- Free Trial Details -->
          <div
            v-if="selectedPlanType === 'free'"
            :class="$style.detailsContent"
          >
            <div :class="$style.detailsContentTitle">
              <h3 class="type-title-large">Free Trial</h3>
              <p class="type-body-medium">$0.00 for 30 days</p>
            </div>
            <div :class="$style.formGrid">
              <div :class="$style.fieldGroup">
                <label
                  for="country"
                  class="type-label-large"
                  >Country</label
                >

                <div :class="$style.selectWrapper">
                  <select
                    id="country"
                    v-model="countryCode"
                    :class="[$style.select, 'type-body-medium']"
                  >
                    <option value="">Select Country</option>
                    <option value="US">United States</option>
                    <option value="CA">Canada</option>
                    <option value="GB">United Kingdom</option>
                    <option value="AU">Australia</option>
                    <option value="DE">Germany</option>
                    <option value="FR">France</option>
                    <option value="NL">Netherlands</option>
                    <option value="IE">Ireland</option>
                    <option value="SE">Sweden</option>
                    <option value="NO">Norway</option>
                    <option value="DK">Denmark</option>
                    <option value="FI">Finland</option>
                    <option value="NZ">New Zealand</option>
                    <option value="SG">Singapore</option>
                    <option value="JP">Japan</option>
                    <option value="IN">India</option>
                    <option value="BR">Brazil</option>
                    <option value="MX">Mexico</option>
                    <option value="ES">Spain</option>
                    <option value="IT">Italy</option>
                    <option value="PT">Portugal</option>
                    <option value="PL">Poland</option>
                    <option value="CH">Switzerland</option>
                    <option value="AT">Austria</option>
                    <option value="BE">Belgium</option>
                  </select>
                  <arrowDown :class="$style.selectArrow" />
                </div>
              </div>
              <div :class="$style.fieldGroup">
                <label
                  for="postalCode"
                  class="type-label-large"
                  >Postal / Zip Code</label
                >
                <input
                  id="postalCode"
                  v-model="postalCode"
                  type="text"
                  :class="[$style.input, 'type-body-medium']"
                  placeholder="e.g. 90210"
                />
              </div>
            </div>

            <div :class="[$style.featuresList, 'type-body-medium']">
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span
                  >Start with 2 team members — invite a recruiter and hiring
                  manager. Yogen works best when your team collaborates.</span
                >
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Full platform access</span>
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Interview training</span>
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Audit tools</span>
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>No credit card required</span>
              </div>
            </div>
          </div>

          <!-- Paid Plan Details -->
          <div
            v-else
            :class="$style.detailsContent"
          >
            <!-- Billing Toggle -->
            <div :class="$style.billingToggle">
              <button
                :class="[
                  $style.billingOption,
                  { [$style.active]: !isAnnual },
                  'type-label-large',
                ]"
                @click="isAnnual = false"
              >
                Monthly
              </button>
              <button
                :class="[
                  $style.billingOption,
                  { [$style.active]: isAnnual },
                  'type-label-large',
                ]"
                @click="isAnnual = true"
              >
                Annual
                <span
                  v-if="isAnnual"
                  :class="[$style.saveBadge, 'type-label-small-emphasized']"
                  >Save 20%</span
                >
              </button>
            </div>

            <!-- User Count -->
            <div :class="$style.userCountSection">
              <label class="type-label-large"
                >Number of Users: <strong>{{ userCount }}</strong></label
              >
              <!-- Self-serve pricing covers 1-20 seats; 21+ is contact-sales -->
              <input
                type="range"
                min="1"
                max="20"
                v-model.number="userCount"
                :class="$style.slider"
                @input="updatePricing"
              />
              <div :class="[$style.sliderLabels, 'type-body-small']">
                <span>1</span>
                <span>20</span>
              </div>
              <p :class="[$style.contactSalesHint, 'type-body-small']">
                Need more than 20 seats?
                <a
                  href="mailto:sales@getyogen.com?subject=Custom plan (20%2B seats)"
                  >Contact sales</a
                >
                for a custom plan.
              </p>
            </div>

            <!-- Price Display (live from Paddle) -->
            <div :class="$style.priceDisplay">
              <div :class="$style.priceMain">
                <span :class="[$style.amount, 'type-headline-medium']">{{
                  pricingLoading ? '…' : pricing?.formattedPerSeat || '—'
                }}</span>
                <span :class="[$style.perUser, 'type-body-medium']"
                  >per seat/{{ isAnnual ? 'year' : 'month' }}</span
                >
              </div>
              <div :class="[$style.priceTotal, 'type-body-medium']">
                30 days free, then
                <strong
                  >{{
                    pricingLoading ? '…' : pricing?.formattedTotal || '—'
                  }}/{{ isAnnual ? 'year' : 'month' }}</strong
                >
              </div>
            </div>

            <div :class="[$style.featuresList, 'type-body-medium']">
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span
                  >{{ userCount }} user license{{
                    userCount > 1 ? 's' : ''
                  }}</span
                >
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Full platform access</span>
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Interview training</span>
              </div>
              <div :class="$style.featureItem">
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Audit tools</span>
              </div>
              <div
                v-if="userCount > 1"
                :class="$style.featureItem"
              >
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Team collaboration</span>
              </div>
              <div
                v-if="userCount >= 5"
                :class="$style.featureItem"
              >
                <svg
                  :class="$style.checkIcon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <span>Priority support</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Display -->
        <div
          v-if="error"
          :class="[$style.errorMsg, 'type-body-medium']"
        >
          {{ error }}
        </div>

        <!-- Action Buttons -->
        <div :class="$style.actions">
          <Button
            v-if="selectedPlanType === 'free'"
            :variant="ButtonVariant.Primary"
            @click="handleFreeSignup"
            :disabled="loading || !countryCode || !postalCode"
            :class="$style.primaryBtn"
          >
            {{ loading ? 'Creating Trial...' : 'Start Free Trial' }}
          </Button>
          <Button
            v-else
            :variant="ButtonVariant.Primary"
            @click="initializeCheckout"
            :disabled="loading"
            :class="$style.primaryBtn"
          >
            {{ loading ? 'Preparing...' : 'Start 30-Day Trial' }}
          </Button>
          <button
            :class="[$style.backBtn, 'type-label-large']"
            @click="$emit('back')"
          >
            Back
          </button>
        </div>
      </div>

      <!-- Step: Inline Checkout (for paid plans) -->
      <div
        v-else-if="checkoutStep === 'checkout'"
        :class="$style.checkoutStep"
      >
        <div :class="$style.checkoutHeader">
          <h3 class="type-title-large">Start Your 30-Day Trial</h3>
          <p class="type-body-medium">
            {{ planName }} - {{ userCount }} seat(s) - 30 days free, then
            {{ pricing?.formattedTotal || '' }}/{{
              isAnnual ? 'year' : 'month'
            }}
          </p>
        </div>

        <PaddleInlineCheckout
          v-if="transactionId"
          :transactionId="transactionId"
          @complete="handleCheckoutComplete"
          @close="checkoutStep = 'select'"
          @error="handleCheckoutError"
        />

        <div :class="$style.checkoutActions">
          <button
            :class="[$style.backBtn, 'type-label-large']"
            @click="checkoutStep = 'select'"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back to Plan Selection
          </button>
        </div>

        <div
          v-if="error"
          :class="[$style.errorMsg, 'type-body-medium']"
        >
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue'
  import LogoComponent from 'assets/svg/yogenLogo.svg'
  import arrowDown from 'assets/svg/chevronDown.svg'
  import paddleAPI from '~/apis/paddleApi'
  import { ButtonVariant } from '~/constants/buttonTypes'
  import PaddleInlineCheckout from '~/components/PaddleInlineCheckout.vue'
  import { useOrgStore } from '~/stores/orgStore'
  import { getSubscriptionPresentation } from '~/utils/subscriptionState'

  interface Props {
    email: string
    password: string
    initialUserCount?: number
    initialIsAnnual?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    initialUserCount: 1,
    initialIsAnnual: true,
  })

  const emit = defineEmits<{
    back: []
    checkout: [checkoutUrl: string, planData: any]
  }>()

  const selectedPlanType = ref<'free' | 'paid'>('free')
  const userCount = ref(props.initialUserCount)
  const isAnnual = ref(props.initialIsAnnual)
  const loading = ref(false)
  const error = ref('')
  const checkoutStep = ref<'select' | 'checkout'>('select')
  const transactionId = ref('')
  const countryCode = ref('US')
  const postalCode = ref('')

  const { previewForSeats } = usePaddle()
  const pricing = ref<{
    formattedPerSeat: string
    formattedTotal: string
  } | null>(null)
  const pricingLoading = ref(false)

  const refreshPricing = async () => {
    if (selectedPlanType.value !== 'paid') return
    pricingLoading.value = true
    try {
      pricing.value = await previewForSeats(userCount.value, isAnnual.value)
    } catch (err) {
      console.error('Error fetching price preview:', err)
      pricing.value = null
    } finally {
      pricingLoading.value = false
    }
  }

  watch([userCount, isAnnual, selectedPlanType], () => {
    refreshPricing()
  })

  const planName = computed(() => {
    return paddleAPI.getPlanName(userCount.value)
  })

  const updatePricing = () => {
    error.value = ''
  }

  const handleFreeSignup = async () => {
    if (!countryCode.value || !postalCode.value) {
      error.value = 'Please select a country and enter your postal code'
      return
    }

    loading.value = true
    error.value = ''

    try {
      const trialResponse = await paddleAPI.createCardlessTrial({
        email: props.email,
        userCount: 2,
        isAnnual: false,
        countryCode: countryCode.value,
        postalCode: postalCode.value,
      })

      // Funnel: the cardless trial was created (Paddle-backed premium starts here).
      useNuxtApp().$posthog?.()?.capture('trial_started', {
        plan_name: 'Free Trial',
        user_count: 2,
      })

      // The backend now persists the trial state synchronously before returning,
      // so refresh the org store from the backend and confirm it reads as
      // trial/trialing before proceeding. This prevents the first post-signup
      // render from briefly showing a "free"/"expired" org. If the refreshed
      // state is momentarily incomplete (e.g. read replica lag), retry a small,
      // bounded number of times — never poll indefinitely.
      const orgStore = useOrgStore()
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          await orgStore.getOrg()
          const state = getSubscriptionPresentation(orgStore.selected)
          if (state === 'trialing' || state === 'paid') break
        } catch (refreshErr) {
          console.warn(
            '[PlanSelector] org refresh after trial failed:',
            refreshErr,
          )
        }
        await new Promise((resolve) => setTimeout(resolve, 400))
      }

      // The account was already created at Step 1 (AuthForm). This data is
      // display-only for /signup-complete; the authoritative org/subscription
      // state lives in the org store (refreshed above) and the backend.
      const signupData = {
        email: props.email,
        planName: 'Free Trial',
        subscriptionId: trialResponse.subscriptionId,
        customerId: trialResponse.customerId,
        trialEndsAt: trialResponse.trialEndsAt,
        countryCode: countryCode.value,
        postalCode: postalCode.value,
        timestamp: Date.now(),
      }
      sessionStorage.setItem('yogen_signup_data', JSON.stringify(signupData))
      useCookie('onboardingRequired').value = 'false'
      navigateTo('/signup-complete')
    } catch (err: any) {
      console.error('Error creating cardless trial:', err)
      error.value = 'Failed to create trial. Please try again.'
      loading.value = false
    }
  }

  const initializeCheckout = async () => {
    loading.value = true
    error.value = ''

    try {
      const checkoutData = {
        email: props.email,
        userCount: userCount.value,
        isAnnual: isAnnual.value,
      }

      const response = await paddleAPI.createCheckoutSession(checkoutData)
      transactionId.value = response.transactionId
      checkoutStep.value = 'checkout'

      // Funnel: the user opened a paid checkout (not yet completed).
      useNuxtApp().$posthog?.()?.capture('checkout_started', {
        plan_name: planName.value,
        user_count: userCount.value,
        is_annual: isAnnual.value,
      })
    } catch (err: any) {
      console.error('Error initializing checkout:', err)
      error.value = 'Failed to create checkout session. Please try again.'
    } finally {
      loading.value = false
    }
  }

  const handleCheckoutComplete = (data: any) => {
    // Account already exists (created at Step 1); this is display-only.
    const signupData = {
      email: props.email,
      planName: planName.value,
      userCount: userCount.value,
      isAnnual: isAnnual.value,
      pricing: pricing.value,
      timestamp: Date.now(),
    }
    sessionStorage.setItem('yogen_signup_data', JSON.stringify(signupData))
    useCookie('onboardingRequired').value = 'false'
    navigateTo('/signup-complete')
  }

  const handleCheckoutError = (errorMsg: string) => {
    error.value = errorMsg
  }

  // When entering the paid plan, default the seat count to 2 (the product's recruiter + hiring
  // manager sweet spot) rather than 1.
  watch(selectedPlanType, (type) => {
    if (type === 'paid' && userCount.value < 2) {
      userCount.value = 2
    }
  })

  onMounted(() => {
    if (props.initialUserCount > 1) {
      selectedPlanType.value = 'paid'
    }
    updatePricing()
    refreshPricing()
  })
</script>

<style module>
  .pageWrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 0;
  }

  .gradientBg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--gradient-background-page);
    z-index: 0;
  }

  .header {
    width: 100%;
    padding: var(--space-20) var(--space-32);
    display: flex;
    align-items: center;
    position: relative;
    z-index: 10;
  }

  .logoSection {
    display: flex;
    align-items: center;
    gap: var(--space-8);
  }

  .logo {
    width: 32px;
    height: 32px;
    filter: none;
  }

  .logoText {
    color: var(--color-text-primary);
  }

  .contentCard {
    position: relative;
    z-index: 10;
    background: var(--color-surface-default);
    border-radius: var(--radius-md);
    border: 1px solid var(--color-border-default);
    width: 100%;
    max-width: 600px;
    margin: var(--space-48) auto;
    padding: var(--space-40) var(--space-20) var(--space-40) var(--space-20);
  }

  .stepper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-8);
    margin-bottom: var(--space-40);
  }

  .stepItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--space-8);
    height: 100%;
    width: 122px;
  }

  .stepNumber {
    width: 48px;
    height: 48px;
    border-radius: var(--radius-full);
    background: var(--color-surface-muted);
    color: var(--color-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .stepLabel {
    color: var(--color-text-secondary);
    white-space: nowrap;
  }

  .stepItem.active .stepNumber {
    background: var(--gradient-brand-medium);
    color: var(--color-text-on-brand);
  }

  .stepItem.active .stepLabel {
    color: var(--color-text-primary);
  }

  .stepItem.completed .stepNumber {
    background: var(--gradient-brand-subtle);
    color: var(--color-text-on-brand);
  }

  .stepItem.completed .stepLabel {
    color: var(--color-text-secondary);
  }

  .planContent {
    display: flex;
    flex-direction: column;
    gap: var(--space-24);
  }

  .formHeader {
    margin-bottom: var(--space-32);
    text-align: center;
  }

  .formTitle {
    color: var(--color-text-primary);
    margin: 0 0 var(--space-8) 0;
  }

  .mascotContainer {
    filter: drop-shadow(var(--effect-brand-glow));
  }

  .planTypeGrid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-16);
  }

  .planTypeCard {
    background: var(--color-surface-default);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-lg);
    padding: var(--space-20);
    cursor: pointer;
    transition: all 0.2s;
    text-align: center;
  }

  .planTypeCard:hover {
    border-color: var(--color-interactive-primary-disabled);
  }

  .planTypeCard.selected {
    border-color: var(--color-interactive-primary-disabled);
    background: var(--color-surface-accent);
  }

  .planTypeCard h3 {
    color: var(--color-text-primary);
    margin: 0 0 var(--space-4);
  }

  .planTypeCard p {
    color: var(--color-text-secondary);
    margin: 0;
  }

  .description p {
    text-align: center;
    color: var(--color-text-secondary);
  }

  .detailsPanel {
    background: var(--color-surface-muted);
    border-radius: var(--radius-lg);
    padding: var(--space-24);
  }

  .detailsPanel h3 {
    color: var(--color-text-primary);
    text-align: center;
  }

  .detailsPanel p {
    color: var(--color-text-secondary);
    text-align: center;
    padding-bottom: var(--space-4);
  }

  .detailsContent {
    display: flex;
    flex-direction: column;
    gap: var(--space-20);
  }

  .detailsContent h3 {
    color: var(--color-text-primary);
  }

  .detailsContent p {
    color: var(--color-text-secondary);
  }

  .detailsContentTitle {
    gap: var(--space-2);
  }

  .formGrid {
    display: grid;
    gap: var(--space-16);
  }

  .fieldGroup {
    display: flex;
    flex-direction: column;
    gap: var(--space-8);
  }

  .fieldGroup label {
    color: var(--color-text-primary);
  }

  .fieldGroup svg {
    height: 12px;
  }

  .selectWrapper {
    position: relative;
    display: flex;
    align-items: center;
  }

  .select {
    padding: var(--space-12) var(--space-16);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    background: var(--color-surface-default);
    color: var(--color-text-primary);
    transition: all 0.2s;
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: var(--space-40);
  }

  .selectArrow {
    position: absolute;
    right: 1rem;
    width: 16px;
    height: 16px !important;
    pointer-events: none;
    color: var(--color-text-secondary);
  }

  .input,
  .select {
    padding: var(--space-12) var(--space-16);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    background: var(--color-surface-default);
    color: var(--color-text-primary);
    transition: all 0.2s;
  }

  .input:focus,
  .select:focus {
    outline: none;
    border-color: var(--color-interactive-primary);
    box-shadow: var(--elevation-md);
  }

  .select {
    cursor: pointer;
  }

  .featuresList {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-8);
  }

  .featureItem {
    display: flex;
    align-items: center;
    gap: var(--space-12);
    color: var(--color-text-primary);
  }

  .checkIcon {
    width: 24px;
    height: 24px;
    color: var(--color-status-success);
    flex-shrink: 0;
  }

  .billingToggle {
    display: flex;
    background: var(--color-border-default);
    border-radius: var(--radius-md);
    padding: var(--space-4);
    gap: var(--space-4);
  }

  .billingOption {
    flex: 1;
    padding: var(--space-8) var(--space-16);
    border: none;
    border-radius: var(--radius-sm);
    background: transparent;
    color: var(--color-text-secondary);
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-8);
  }

  .billingOption.active {
    background: var(--color-surface-default);
    color: var(--color-text-primary);
    box-shadow: var(--elevation-md);
  }

  .saveBadge {
    background: var(--color-status-success);
    color: var(--color-text-on-brand);
    padding: var(--space-2) var(--space-8);
    border-radius: var(--radius-sm);
    white-space: nowrap;
  }

  .userCountSection {
    display: flex;
    flex-direction: column;
    gap: var(--space-12);
  }

  .userCountSection label {
    color: var(--color-text-primary);
  }

  .userCountSection label strong {
    color: var(--color-interactive-primary);
  }

  .slider {
    width: 100%;
    height: 6px;
    border-radius: var(--radius-full);
    background: var(--color-border-default);
    outline: none;
    -webkit-appearance: none;
    appearance: none;
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 18px;
    height: 18px;
    border-radius: var(--radius-full);
    background: var(--color-interactive-primary);
    cursor: pointer;
    box-shadow: var(--elevation-md);
  }

  .slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: var(--radius-full);
    background: var(--color-interactive-primary);
    cursor: pointer;
    border: none;
  }

  .sliderLabels {
    display: flex;
    justify-content: space-between;
    color: var(--color-text-disabled);
  }

  .contactSalesHint {
    margin: var(--space-8) 0 0;
    color: var(--color-text-secondary);
  }

  .contactSalesHint a {
    color: var(--color-interactive-primary);
  }

  .priceDisplay {
    background: var(--color-surface-default);
    border-radius: var(--radius-md);
    padding: var(--space-16);
    text-align: center;
  }

  .priceMain {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: var(--space-4);
    margin-bottom: var(--space-8);
  }

  .currency {
    color: var(--color-interactive-primary);
  }

  .amount {
    color: var(--color-interactive-primary);
  }

  .perUser {
    color: var(--color-text-secondary);
    margin-left: var(--space-4);
  }

  .priceTotal {
    color: var(--color-text-primary);
  }

  .priceTotal strong {
    color: var(--color-text-primary);
  }

  .actions {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: var(--space-16);
    padding-top: var(--space-16);
  }

  .backBtn {
    align-items: center;
    padding: var(--space-20) 0 0 0;
    border: none;
    background: transparent;
    color: var(--color-interactive-link);
    cursor: pointer;
    width: 100%;
  }

  .backBtn:hover {
    color: var(--color-text-primary);
  }

  .primaryBtn {
    flex: 1;
    max-width: 100%;
  }

  .errorMsg {
    background: var(--color-status-error-subtle);
    border: 1px solid var(--color-status-error);
    color: var(--color-status-error);
    padding: var(--space-12) var(--space-16);
    border-radius: var(--radius-md);
    text-align: center;
  }

  .checkoutStep {
    display: flex;
    flex-direction: column;
    gap: var(--space-24);
  }

  .checkoutHeader {
    text-align: center;
    padding-bottom: var(--space-24);
    border-bottom: 1px solid var(--color-border-default);
  }

  .checkoutHeader h3 {
    color: var(--color-text-primary);
    margin: 0 0 var(--space-8);
  }

  .checkoutHeader p {
    color: var(--color-text-secondary);
    margin: 0;
  }

  .checkoutActions {
    display: flex;
    justify-content: center;
    padding-top: var(--space-16);
    border-top: 1px solid var(--color-border-default);
  }

  @media (max-width: 640px) {
    .contentCard {
      margin: 0 var(--space-16) var(--space-32);
      padding: var(--space-24);
      border-radius: var(--radius-full);
    }

    .stepper {
      gap: 0;
      padding: var(--space-12) 0 var(--space-24);
    }

    .stepLabel {
    }

    .stepNumber {
      width: 32px;
      height: 32px;
    }

    .planTypeGrid {
      grid-template-columns: 1fr;
    }

    .formGrid {
      grid-template-columns: 1fr;
    }

    .actions {
      flex-direction: column;
    }

    .backBtn {
      order: 2;
    }

    .primaryBtn {
      max-width: none;
      width: 100%;
      order: 1;
    }

    .header {
      padding: var(--space-16);
    }
  }
</style>
